import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const featuredCategories = categories.slice(0, 6);

const cardImages = [
  'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20white%20leather%20sneakers%20on%20warm%20cream%20surface%2C%20soft%20studio%20lighting%20from%20left%2C%20Scandinavian%20product%20photography%2C%20clean%20neutral%20aesthetic%2C%20gentle%20shadows%2C%20editorial%20fashion%20composition&width=600&height=800&seq=cat-v2-shoes&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Soft%20beige%20cashmere%20hoodie%20flat%20lay%20on%20warm%20cream%20backdrop%2C%20delicate%20natural%20window%20light%2C%20minimalist%20Scandinavian%20product%20photography%2C%20clean%20aesthetic%2C%20neutral%20warm%20tones%2C%20gentle%20fabric%20texture&width=600&height=800&seq=cat-v2-hoodies&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Pure%20white%20organic%20cotton%20t-shirt%20folded%20neatly%20on%20light%20cream%20surface%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20Scandinavian%20aesthetic%2C%20warm%20neutral%20tones%2C%20crisp%20fabric%20detail&width=600&height=800&seq=cat-v2-tshirts&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Elegant%20camel%20wool%20blazer%20jacket%20on%20warm%20cream%20backdrop%2C%20natural%20soft%20lighting%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20Scandinavian%20aesthetic%2C%20sophisticated%20neutral%20composition%2C%20tailored%20detail&width=600&height=800&seq=cat-v2-jackets&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Refined%20beige%20linen%20trousers%20flat%20lay%20on%20warm%20cream%20surface%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20aesthetic%2C%20neutral%20warm%20tones%2C%20relaxed%20elegant%20fabric%20texture&width=600&height=800&seq=cat-v2-pants&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20accessories%20arrangement%20with%20sunglasses%20and%20leather%20watch%20on%20warm%20cream%20backdrop%2C%20soft%20natural%20lighting%2C%20clean%20Scandinavian%20aesthetic%2C%20refined%20neutral%20composition%2C%20gentle%20reflections&width=600&height=800&seq=cat-v2-accessories&orientation=portrait',
];

const buttonStyles = ['bg-primary-500 text-background-50 hover:bg-primary-600', 'border-2 border-foreground-300 text-foreground-700 hover:border-foreground-500', 'border-2 border-foreground-300 text-foreground-700 hover:border-foreground-500'];

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            Categorie Popolari
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg">
            Esplora le nostre categorie organizzate per trovare esattamente ci&ograve; che cerchi con Itaobuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredCategories.map((cat, idx) => (
            <div key={cat.name} className="rounded-2xl bg-background-50 overflow-hidden group">
              <div className="relative overflow-hidden" style={{ aspectRatio: '3/4' }}>
                <img
                  src={cardImages[idx]}
                  alt={`${cat.name} - Itaobuy Spreadsheet`}
                  title={`${cat.name} Itaobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-800 mb-2 text-center">{cat.name}</h3>
                <a
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className={`block w-full py-3 rounded-full text-sm font-semibold text-center transition-all duration-300 cursor-pointer whitespace-nowrap ${buttonStyles[idx % 3]}`}
                >
                  Esplora {cat.name}
                  <i className="ri-arrow-right-line ml-1.5"></i>
                </a>
                <p className="text-[11px] text-foreground-400 mt-2 text-center">Prodotti aggiornati</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/articolo/itaobuy-spreadsheet-categorie-guida"
            className="inline-flex items-center gap-2 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Vedi tutte le 14 categorie
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}